export default "__VITE_ASSET__CYroSwqt__"